import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";


export const GetSearchParams: React.FunctionComponent<{
    setParams: (params: Map<string, string>) => void
}> = ({
    setParams
}) => {
    const [urlSearchParams] = useSearchParams();

    useEffect(() => {
        const normalizedSearchParams = new Map<string, string>();

        urlSearchParams.forEach((value, key) => {
            normalizedSearchParams.set(key.toLowerCase(), value);
        });

        setParams(normalizedSearchParams);
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [urlSearchParams]);

    return null;
}